import { Component } from 'preact';
import { TransitionGroup } from 'react-transition-group';
import SlideDownTransition from '../transitions/SlideDownTransition';

// eslint-disable-next-line react/prefer-stateless-function
export default class SlideDownReveal extends Component {

	render({ children, visible, timeout=700, delay=0, appear }) {
		return (
			<TransitionGroup>
				{ visible ? (
					<SlideDownTransition {...{ timeout, delay, appear }}>
						<div className="slide-transition">{children}</div>
					</SlideDownTransition>
				) : null }
			</TransitionGroup>
		);
	}
}



// WEBPACK FOOTER //
// ./components/effects/SlideDownReveal.js